import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import GoalsArchiveTable from "./GoalsArchiveTable";

const GoalsArchive = () => {
	const goalArchive = useSelector((state: any) => state.goalArchive.data);
	const isLoading = useSelector((state: any) => state.goalArchive.isLoading);

	return (
		<div className="container dashboards">
			<div className="row">
				<div className="col-md-12">
					<Link to="/admin/goals">&lt; Back</Link>
				</div>
			</div>
			<div className="row">
				<div className="col-md-12">
					<div className="dashboards__header">
						<h1>{!isLoading && goalArchive?.goal?.title}</h1>
						<div className="dashboards__links"></div>
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col-md-12">
					<GoalsArchiveTable />
				</div>
			</div>
		</div>
	);
};

export default GoalsArchive;
